// File: src/components/common/ActingAsBanner.jsx
//
// Persistent banner shown whenever an admin/ServiceProviderAdmin is acting
// on behalf of a selected instructor. Reinforces requirement: "The system
// should clearly indicate which instructor is currently selected."

import React from 'react';
import { UserCog, X } from 'lucide-react';
import { useActingAs } from '../../context/ActingAsContext';

const ActingAsBanner = () => {
  const { selectedInstructor, isActingAsSelf, clearActingAs } = useActingAs();

  if (isActingAsSelf) return null;

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      gap: '0.75rem', padding: '0.6rem 1.25rem',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: '#fff', fontSize: '0.85rem', fontWeight: 600,
      fontFamily: "'DM Sans','Segoe UI',sans-serif"
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <UserCog size={16} />
        <span>
          You are managing <strong>{selectedInstructor.instructorName}</strong>'s templates and configuration.
          All changes apply to this instructor's account.
        </span>
      </div>
      <button
        onClick={() => { clearActingAs(); window.location.reload(); }}
        style={{
          display: 'flex', alignItems: 'center', gap: '0.3rem',
          background: 'rgba(255,255,255,0.18)', border: 'none',
          borderRadius: '0.4rem', padding: '0.3rem 0.7rem',
          color: '#fff', fontSize: '0.78rem', fontWeight: 600,
          cursor: 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap'
        }}
      >
        <X size={13} /> Stop managing
      </button>
    </div>
  );
};

export default ActingAsBanner;
